import { JSX } from 'react';
import {
    Edit,
    SimpleForm,
    TextInput,
    required,
    SelectInput,
    ReferenceInput
} from 'react-admin';
import { ChatFieldBridge } from "../chat-bot/components/ChatFieldBridge";

export const AdminUrlEdit: () => JSX.Element = (): JSX.Element => {

    return (
        <Edit>
            <SimpleForm>
                <TextInput name="path" source="path" validate={[required()]} fullWidth />
                <ReferenceInput
                    label="website"
                    source="website"
                    reference="websites"
                    >
                    <SelectInput optionText="baseUrl" fullWidth/>
                </ReferenceInput>
                {/* Offers this form to the assistant. Renders nothing, writes nothing by itself. */}
                <ChatFieldBridge />
            </SimpleForm>
        </Edit>
    );
}